import { FormFeedback } from 'reactstrap';
import React from 'react';
import _ from 'lodash';

/**
 * ErrorRenderer function
 * @param {*} errors - Errors Object
 * @param {*} fieldName - Field name
 * @returns - FormFeedback with message
 */

export const errorRenderer = (errors, fieldName) => {
  return errors && errors[fieldName] ? (
    <FormFeedback className="d-block">{errors[fieldName].message}</FormFeedback>
  ) : undefined;
};

// @@ React-Select Error styles
export const reactSelectErrorStyles = {
  control: (provided) => ({
    ...provided,
    border: '1px solid #ea5455 !important',
  }),
};

export const generateDistinctColor = (str) => {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var colour = '#';
  for (var i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 0xff;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
};

// ** Function to extract initials from content
export const getInitials = (str) => {
  const results = [];
  const wordArray = str.split(' ');
  wordArray.forEach((e) => {
    results.push(e[0]);
  });
  return results.join('');
};

export const currentCompany = () => {
  let cid = localStorage.getItem('cid');
  return !_.isEmpty(cid) ? cid : '';
};

export const getFormattedDate = (date) => {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  if (day < 10) day = `0${day}`;
  if (month < 10) month = `0${month}`;
  return `${day}:${month}:${year}`;
};

export function convertMinutes(inputMinutes) {
  let hours = Math.floor(inputMinutes / 60);
  let minutes = Math.floor(inputMinutes % 60);
  let seconds = Math.round((inputMinutes % 1) * 60);
  if (isNaN(hours)) hours = 0;
  if (isNaN(minutes)) minutes = 0;
  if (isNaN(seconds)) seconds = 0;
  return { hours, minutes, seconds };
}

export const getTimeByDateString = (dateString) => {
  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);
  const hour = dateString.slice(8, 10);
  const minute = dateString.slice(10, 12);
  const second = dateString.slice(12, 14);

  const localeTimeString = new Date(
    `${year}-${month}-${day}T${hour}:${minute}:${second}`
  ).toLocaleTimeString();
  return localeTimeString;
};

function lastPathSegment(path) {
  if (!path || typeof path !== 'string') return '';
  const parts = path.split(/[/\\]/).filter(Boolean);
  return parts.length ? parts[parts.length - 1] : '';
}

/** From paths like /.../Google Chrome.app/Contents/MacOS/... → "Google Chrome". */
function deriveMacBundleDisplayName(path) {
  if (!path || typeof path !== 'string') return '';
  const segments = path.split(/[/\\]/).filter(Boolean);
  const appSegment = [...segments].reverse().find((s) => /\.app$/i.test(s));
  if (!appSegment) return '';
  return appSegment.replace(/\.app$/i, '').trim();
}

/** Heuristic labels only; keeps Firestore-provided strings unchanged when used from mapping. */
function capitalizeFirstLetter(label) {
  if (!label || typeof label !== 'string') return label;
  return label.charAt(0).toUpperCase() + label.slice(1);
}

function firstMappedDisplayValue(map, keys) {
  for (let i = 0; i < keys.length; i += 1) {
    const k = keys[i];
    if (k == null || k === '') continue;
    const v = map[k];
    if (v == null || v === '') continue;
    if (typeof v === 'string') return v;
    if (Array.isArray(v)) {
      const s = v.find((x) => typeof x === 'string');
      if (s) return s;
    }
  }
  return null;
}

/**
 * Resolve a friendly app label from a Windows or macOS path using `applicationInfo` maps.
 * Firestore values always win when any known key matches; otherwise macOS `.app` bundle name, else last segment.
 */
export const getAppNameByAppPath = (path, appNameMapping) => {
  const map =
    appNameMapping && typeof appNameMapping === 'object' ? appNameMapping : {};
  if (path == null || path === '') return 'Unknown';
  if (typeof path !== 'string') return 'Unknown';

  const lastSeg = lastPathSegment(path);
  const bundleLabel = deriveMacBundleDisplayName(path);

  const mapped = firstMappedDisplayValue(map, [
    path,
    lastSeg,
    bundleLabel,
    bundleLabel ? `${bundleLabel}.app` : '',
  ]);

  if (mapped) return mapped;
  if (bundleLabel) return capitalizeFirstLetter(bundleLabel);
  if (lastSeg) return capitalizeFirstLetter(lastSeg);
  return capitalizeFirstLetter(path);
};
